const $ = jQuery.noConflict();

export function setupSliders(){
   $('.evtx-slider').each(function(){
      const $this = $(this);

      const userOpts = $this.attr('data-options');
      let opts = {
         arrows: $this.hasClass('slider-arrows'),
         autoplay: $this.hasClass('slider-autoplay'),
      };
      if (userOpts) {
         try {
            const parsed = JSON.parse($this.attr('data-options'));
            opts = { ...opts, ...parsed };
         }
         catch (e) {
            // don't merge in options
         }
      }
      $this.slick(opts);
   });
}
